export default __webpack_public_path__ + "media/images/social-facebook-35332a1ae93607c4d57db68bc2bf0ae5.svg";